import { render, staticRenderFns } from "./EditToolbar.vue?vue&type=template&id=b0d5be4c&"
import script from "./EditToolbar.vue?vue&type=script&lang=js&"
export * from "./EditToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports